import {theme} from "@chakra-ui/core";

export default {
  ...theme,
  colors: {
    ...theme.colors,
    primary: {
      ...theme.colors.green,
      50: "#EBF5F0",
      100: "#EBF5F0",
      200: "#D4ECC4",
      300: "#62997E",
      400: "#62997E",
      500: "#22594B",
      600: "#22594B",
      700: "#22594B",
      800: "#22594B",
      900: "#162D27",
    },
  },
};
